import PropTypes from 'prop-types';
import { SOCIAL_MEDIA_SITES } from '../../../services/utilityFunctions';

const propType = {
  share: PropTypes.shape({
    image: PropTypes.string,
    keywords: PropTypes.arrayOf(PropTypes.string),
    url: PropTypes.string,
    description: PropTypes.string,
    title: PropTypes.string,
  }),
  companyLinks: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  socialMedia: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      site: PropTypes.oneOf(SOCIAL_MEDIA_SITES),
    }),
  ),
  footerLogo: PropTypes.string,
  testimonials: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      text: PropTypes.string,
      role: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  supportEmail: PropTypes.string,
  contactEmail: PropTypes.string,
  clients: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      image: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  description: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  heroImage: PropTypes.string,
};

export default { propType };
